import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/upload/uploadFile';
import { searchWinBidSupplier } from '../../../api';
import formHelpers from './utils/form';
import { createBiddingSupplierRow, normalizeCustomerId } from './utils/taskData';
import SectionEditActions from './SectionEditActions';
export default {
  name: 'BidOpeningDeliverySection',
  components: {
    UploadFile: UploadFile,
    SectionEditActions: SectionEditActions
  },
  mixins: [formHelpers],
  inject: {
    elForm: {
      default: null
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    editSaving: {
      type: Boolean,
      default: false
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    showProjectInfoEditButton: {
      type: Function,
      required: true
    },
    startProjectInfoEdit: {
      type: Function,
      required: true
    },
    confirmProjectInfoEdit: {
      type: Function,
      required: true
    },
    cancelProjectInfoEdit: {
      type: Function,
      required: true
    }
  },
  computed: {
    biddingAnnouncementImageSrcList: function biddingAnnouncementImageSrcList() {
      var _this$formData$items,
        _this$formData$items$,
        _this = this;
      return (((_this$formData$items = this.formData.items) === null || _this$formData$items === void 0 ? void 0 : (_this$formData$items$ = _this$formData$items.bidding_support) === null || _this$formData$items$ === void 0 ? void 0 : _this$formData$items$.announcement) || []).filter(function (item) {
        return _this.isImageFile(item);
      }).map(function (item) {
        return _this.$ossurl + item.url;
      });
    }
  },
  methods: {
    changeBiddingResult: function changeBiddingResult() {
      var _this2 = this;
      var bidding = this.formData.items.bidding_support;
      // 切换开标结果时始终清空原因，避免离开「未中标」后 reason 残留脏值被提交
      bidding.reason = '';
      if (Number(bidding.task_status) === 550) {
        bidding.supplier[0].is_win = true;
        bidding.delivery_status = '550';
      } else {
        bidding.supplier[0].is_win = false;
        bidding.delivery_status = '';
      }
      this.$nextTick(function () {
        _this2.elForm && _this2.elForm.validateField('items.bidding_support.supplier');
      });
    },
    changeDeliveryResult: function changeDeliveryResult() {
      var bidding = this.formData.items.bidding_support;
      if (Number(bidding.delivery_status) === 550 || Number(bidding.delivery_status) === 600) {
        bidding.task_status = '550';
      }
    },
    isBiddingWinDisabled: function isBiddingWinDisabled(index) {
      var taskStatus = this.formData.items.bidding_support.task_status;
      if (index === 0 && (taskStatus === '500' || taskStatus === '550')) {
        return true;
      }
      return false;
    },
    addBiddingSupplier: function addBiddingSupplier() {
      this.formData.items.bidding_support.supplier.push(createBiddingSupplierRow());
    },
    // 参标供应商远程搜索：结果替换选项列表，已选中项补回保证回显
    searchSupplierOptions: function searchSupplierOptions(keyword, supplier) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, list, selectedId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return searchWinBidSupplier({
                keyword: (keyword || '').trim()
              });
            case 1:
              res = _context.v;
              list = (res.data || []).map(function (item) {
                return {
                  id: String(item.id),
                  company_name: item.company_name
                };
              });
              selectedId = normalizeCustomerId(supplier.customer_id);
              if (selectedId && !list.some(function (item) {
                return item.id === selectedId;
              })) {
                list.unshift({
                  id: selectedId,
                  company_name: supplier.company_name
                });
              }
              supplier.options = list;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 选中时同步供应商名称；清空时一并清掉，避免旧名称继续参与提交
    changeSupplierOption: function changeSupplierOption(supplier, id) {
      var option = (supplier.options || []).find(function (item) {
        return item.id === id;
      });
      supplier.company_name = option ? option.company_name : '';
    },
    // 展开时按空关键字刷新默认列表，避免只剩已选项或上次搜索结果
    handleSupplierVisible: function handleSupplierVisible(visible, supplier) {
      if (visible) {
        this.searchSupplierOptions('', supplier);
      }
    },
    removeBiddingSupplier: function removeBiddingSupplier(index) {
      var _this3 = this;
      this.formData.items.bidding_support.supplier.splice(index, 1);
      this.$nextTick(function () {
        _this3.elForm && _this3.elForm.validateField('items.bidding_support.supplier');
      });
    },
    handleBiddingAnnouncementUploaded: function handleBiddingAnnouncementUploaded(key, url, fileName, uid) {
      this.formData.items.bidding_support.announcement.push({
        file_name: fileName,
        url: key
      });
    },
    deleteBiddingAnnouncement: function deleteBiddingAnnouncement(index) {
      this.formData.items.bidding_support.announcement.splice(index, 1);
    }
  }
};